import { Button, Form, InputGroup } from "react-bootstrap";
import { useState } from "react";
import { Alert, Input, Snackbar, TextField } from "@mui/material";
import emailjs from '@emailjs/browser';

export default function RegPayment(data) {
  const [notificationType, setNotificationType] = useState("success");
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const vertical = "top";
  const horizontal = "center";
  const [loading, setLoading] = useState(false);
  const [showPage, setShowPage] = useState(false)
  const [formData, setFormData] = useState({
    transactionID: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData)

    try {
      setLoading(true);
      const result = await emailjs.sendForm("service_t9921bc", "template_h4dcpu7", e.currentTarget, "user_YHNnHW5RX67R3vNjN8NfT");

      console.log("SUCCESS!", result.text);
      setShowPage(true)
      setLoading(false);

      setFormData({
        transactionID: "",
      });
      setLoading(false);
    } catch (error) {
      setShowNotification(true)
      setLoading(false);
      console.error("Error sending message:", error);
      setNotificationType("error");
      setMessage("There was an issue sending your message. Please try again later or send your transcation ID to support@coinsmentorship.com");
    }
  };

  return (
    <>
      {
        showPage ? <div className="bg-white md:w-1/2 mx-auto md:mt-32 mt-16 p-3 text-muted flex justify-center items-center">
          <div>
            <p>We will carefully review your receipt and confirm the details. Upon verification, your designated signup link will be provided to you via the email address you provided to complete the registration process.</p>
            <p className="mt-4">We appreciate your patience!</p>
          </div>

        </div> : <div className="my-16">
          <Snackbar
            open={showNotification}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert message={message} severity={notificationType}>
              {message}
            </Alert>
          </Snackbar>
          <div className="bg-white p-3 rounded border border-white shadow-2xl shadow-bg-gray-300 inset-40">
            <div className="text-center">
              <h2 className="text-2xl">Choose Your Path To Success</h2>
              <p className="text-muted">Scan the QR code or copy the wallet address</p>
            </div>
            <div className="text-center">
              <div className="flex justify-center items-center mb-4">
                <img src="/bitcoin.jpg" className="w-[180px] h-[180px]" alt="Bitcoin" />

              </div>
              <span className="text-xs font-medium text-primary mb-4 bg-[#5028F0]/10 px-3 py-1 rounded-full">
                Bitcoin
              </span>
            </div>
            <form onSubmit={handleSubmit}>
              <input value={data.data} hidden name="amount" />
              <p className="text-center mt-4">Transfer $<span className="font-bold">{data?.data}</span> to the wallet below</p>
              <InputGroup className="mb-4 mt-4">
                <Form.Control
                  type="text"
                  placeholder="Disabled input"
                  aria-label="Disabled input example"
                  disabled
                  value={"bc1qdj35cntspm3rvrscrur5trmwlz4ghnqe3fgvz9"}
                  readOnly
                />
                <Button
                  variant="contained"
                  className="!bg-[#101010] !text-white"
                  id="button-addon2"
                  onClick={() => {
                    setShowNotification(true);
                    navigator.clipboard.writeText("bc1qdj35cntspm3rvrscrur5trmwlz4ghnqe3fgvz9");
                    setNotificationType("success");
                    setMessage("Wallet address Copied!");
                    setTimeout(() => setShowNotification(false), 4000);
                  }}
                >
                  Copy
                </Button>
              </InputGroup>
              <div>
                <Input
                  id="standard-adornment-otp"
                  className="text-black w-full"
                  required
                  type="email" name="email"
                  onChange={handleChange}
                  placeholder="Enter your Email"
                />
                <div className="mb-8">
                  <TextField
                    id="standard-basic"
                    className="w-full !text-black"
                    label="Enter Transaction ID"
                    variant="standard"
                    name="transactionID"
                    required
                    onChange={handleChange}
                  />
                </div>
                <Button
                  className="w-full !bg-[#101010] !text-white"
                  variant="contained"
                  type="submit"
                >
                  {loading ? "Loading" : "Confirm Payment"}

                </Button>
              </div>
            </form>
          </div>
        </div>
      }
    </>

  );
}
